export const authEventsConstants = {
	/** @deprecated No live path broadcasts this since Auth0 became the only auth flow. */
	OCA_CONFIRMED: 'e:oca:loginConfirmed',
	AUTH0_CONFIRMED: 'e:auth0:loginConfirmed',
	LOGIN: 'e:loginRequired',
	BUFFER_LOGIN: 'e:buffer:loginRequired',
};
let compMod = angular.module('auth.constants', []).constant('AUTH_EVENTS', authEventsConstants);
export default (compMod = compMod.name);
